// extracted by mini-css-extract-plugin
module.exports = {"publication-container":"publications-m__publication-container__2UU_m","wrapper":"publications-m__wrapper__33DHS","header-wrapper":"publications-m__header-wrapper__3mkM4"};